import styled from 'styled-components';

import { JobTeaserCardSkeleton } from '@xing-com/crate-jobs-xinglets';

export const CardSkeleton = styled(JobTeaserCardSkeleton)`
  height: 330px;
  width: 300px;
`;
